import { AfterViewInit, Component, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-floating-bar',
  templateUrl: './floating-bar.component.html',
  styleUrls: ['./floating-bar.component.scss']
})
export class FloatingBarComponent implements AfterViewInit {
  isEnquiryOpen = false;
  isWhatsappExpanded = false;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    // NoPaperForms widgets are heavy third-party scripts, so they load on the
    // visitor's first interaction instead of slowing down the first page load.
    const events = ['pointerdown', 'keydown', 'scroll', 'touchstart'];
    const load = (): void => {
      events.forEach(event => window.removeEventListener(event, load));
      this.loadWidgets();
    };
    events.forEach(event => window.addEventListener(event, load, { once: true, passive: true }));
  }

  private loadWidgets(): void {
    const widget = this.elementRef.nativeElement.querySelector('.npf_wgts');
    if (widget && !document.querySelector('script[data-npf-widget]')) {
      this.appendScript('https://widgets.nopaperforms.com/emwgts.js', 'data-npf-widget');
    }

    if (!document.querySelector('script[data-npf-chatbot]')) {
      this.appendScript(
        'https://chatbot.in1.nopaperforms.com/en-gb/backend/bots/niaachtbtscpt.js/4885f35478c51848/9d4303fa6f5d402cb4dcd0e0b7c88f29',
        'data-npf-chatbot'
      );
    }
  }

  private appendScript(src: string, marker: string): void {
    const script = this.renderer.createElement('script');
    script.src = src;
    script.async = true;
    this.renderer.setAttribute(script, marker, 'true');
    this.renderer.appendChild(document.body, script);
  }

  toggleEnquiry(): void {
    this.isEnquiryOpen = !this.isEnquiryOpen;
  }

  closeEnquiry(): void {
    this.isEnquiryOpen = false;
  }

  @HostListener('window:scroll')
  updateWhatsappExpansion(): void {
    this.isWhatsappExpanded = window.scrollY > 0;
  }

  @HostListener('document:keydown.escape')
  closeOverlaysOnEscape(): void {
    this.isEnquiryOpen = false;
  }
}
